import React from "react";
import { LegacyCard, InlineGrid, TextField, Select } from "@shopify/polaris";
import CustomAutocomplete from "../CustomAutocomplete";
import { ButtonNumber, ButtonNumberShirt } from "../CoatData";

const combinedButtonNumbers = [...ButtonNumberShirt, ...ButtonNumber];

const PartsOrderCollarForm = ({ form, setForm, errors }) => {
  const sectionKey = "partsOrderCollar";

  const handleChange = (key) => (values) => {
    const value = Array.isArray(values) ? values[0] : values;
    setForm((prev) => ({
      ...prev,
      [sectionKey]: {
        ...prev[sectionKey],
        [key]: value,
      },
    }));
  };

  const collarOptions = [
    "MR Classic",
    "MR Narrow",
    "MR Spread",
    "MR Wing",
    "MR Band",
    "MR Cuban",
    "Tall Collar",
  ];
  const pointLengthOptions = ['2.75"', '2.5"', '3"', '3.25"'];
  const frontHeightOptions = ['1.25"', '1"', '1.5"', '2"'];
  const backHeightOptions = ['1"', '1.25"', '1.5"', '1.75"', '2"'];
  const buttonDownOptions = ["No", "Hidden Button Down", "Classic Button Down"];

  return (
    <LegacyCard title="Parts Order Collar" sectioned>
      <InlineGrid columns={{ xs: 1, sm: 1, md: 2, lg: 3 }} gap="300">
        <TextField
          label="Original Order Number"
          value={form[sectionKey]?.orginalOrderNumber || ""}
          onChange={handleChange("orginalOrderNumber")}
          error={errors[sectionKey]?.orginalOrderNumber}
          autoComplete="off"
        />
        <Select
          label="Collar"
          options={collarOptions}
          value={form[sectionKey]?.collar || ""}
          onChange={handleChange("collar")}
          error={errors[sectionKey]?.collar}
        />
        <Select
          label="Point Length"
          options={pointLengthOptions}
          value={form[sectionKey]?.pointLength || ""}
          onChange={handleChange("pointLength")}
          error={errors[sectionKey]?.pointLength}
        />
        <Select
          label="Front Height"
          options={frontHeightOptions}
          value={form[sectionKey]?.frontHeight || ""}
          onChange={handleChange("frontHeight")}
          error={errors[sectionKey]?.frontHeight}
        />
        <Select
          label="Back Height"
          options={backHeightOptions}
          value={form[sectionKey]?.backHeight || ""}
          onChange={handleChange("backHeight")}
          error={errors[sectionKey]?.backHeight}
        />
        <Select
          label="Button Down"
          options={buttonDownOptions}
          value={form[sectionKey]?.buttonDown || ""}
          onChange={handleChange("buttonDown")}
          error={errors[sectionKey]?.buttonDown}
        />
        <CustomAutocomplete
          label="Button Number"
          optionsList={combinedButtonNumbers}
          onChange={handleChange("buttonNumber")}
          defaultValue={form[sectionKey]?.buttonNumber || ""}
        />
        <TextField
          label="Neck Measurement"
          type="number"
          value={form[sectionKey]?.neckMeasurement || ""}
          onChange={handleChange("neckMeasurement")}
          error={errors[sectionKey]?.neckMeasurement}
          autoComplete="off"
        />
      </InlineGrid>
    </LegacyCard>
  );
};

export default PartsOrderCollarForm;
